import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.transatelMobileProduct.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "transatelMobileProductSearch",
  fields: [
    name
  ]
}
